var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 38.7498C22.4395 38.7498 15.5 31.8103 15.5 23.2498V8.89799C15.5 7.82888 15.5 7.29433 15.6558 6.86629C15.9169 6.14872 16.4822 5.58347 17.1997 5.3223C17.6278 5.1665 18.1623 5.1665 19.2314 5.1665H42.7685C43.8376 5.1665 44.3721 5.1665 44.8002 5.3223C45.5177 5.58347 46.083 6.14872 46.3442 6.86629C46.5 7.29433 46.5 7.82888 46.5 8.89799V23.2498C46.5 31.8103 39.5604 38.7498 31 38.7498ZM31 38.7498V46.4998M46.5 10.3332H52.9583C54.162 10.3332 54.7638 10.3332 55.2386 10.5298C55.8715 10.792 56.3745 11.2949 56.6367 11.9279C56.8333 12.4026 56.8333 13.0045 56.8333 14.2082V15.4998C56.8333 17.9023 56.8333 19.1035 56.5692 20.089C55.8526 22.7635 53.7636 24.8525 51.0891 25.5691C50.1036 25.8332 48.9024 25.8332 46.5 25.8332M15.5 10.3332H9.04163C7.83794 10.3332 7.2361 10.3332 6.76136 10.5298C6.12837 10.792 5.62546 11.2949 5.36327 11.9279C5.16663 12.4026 5.16663 13.0045 5.16663 14.2082V15.4998C5.16663 17.9023 5.16663 19.1035 5.4307 20.089C6.14732 22.7635 8.23632 24.8525 10.9108 25.5691C11.8963 25.8332 13.0975 25.8332 15.5 25.8332M19.2314 56.8332H42.7685C43.4026 56.8332 43.9166 56.3191 43.9166 55.685C43.9166 50.6122 39.8043 46.4998 34.7314 46.4998H27.2685C22.1956 46.4998 18.0833 50.6122 18.0833 55.685C18.0833 56.3191 18.5973 56.8332 19.2314 56.8332Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.1ee767910f79247b2e441d93f5bf4896.svg";
export { ForwardRef as ReactComponent };